import { InjectionToken, Provider } from '@angular/core';
import { initializeApp } from 'firebase/app';
import { Analytics, getAnalytics } from 'firebase/analytics';
import { Firestore, connectFirestoreEmulator, getFirestore } from 'firebase/firestore';
import { environment } from '../environments/environment';

/**
 * Firebase без @angular/fire: AngularFire отстаёт от Angular (стабильный —
 * только до Angular 20), меню — на Angular 22. Сервисы получают Firestore
 * по классу SDK (`private store: Firestore`), подписки — rxfire
 * (docData, collectionData)
 */
export const ANALYTICS = new InjectionToken<Analytics>('Firebase Analytics');

export const firebaseProviders: Provider[] = [
  {
    provide: Firestore,
    useFactory: () => {
      const firestore = getFirestore(initializeApp(environment.firebaseDatabase));
      if (environment.useEmulators) connectFirestoreEmulator(firestore, '127.0.0.1', 8080);
      return firestore;
    },
  },
  {
    provide: ANALYTICS,
    useFactory: () => getAnalytics(initializeApp(environment.firebaseAnalytics, 'analytics')),
  },
];
